import React, { useEffect } from "react";
import * as WidgetUtils from "../logic/WidgetUtils";

// Externals
import cn from "classnames";

// DevExtreme components
import { Toolbar, Item } from 'devextreme-react/toolbar';

// Component styles
import classes from "./DecisionsWidget.module.scss";

export function DecisionsWidget(props) {
  const { ui, data, config, doAction } = props;

  let widgetId = ui.id;
  let buttons = config ? config.Buttons : null;
  let content = data ? JSON.parse(data.content) : null;

  let disabledByUi = ui.readonly;
  let disabledByData = data && data.readonly;
  let disabledToolbar = disabledByUi || disabledByData;

  useEffect(() => {
    //console.log("DecisionsWidget data of " + ui.id + ": ", data);
  }, [data]);

  const findIcon = actionId => {
    switch (actionId) {
      case "WORK":
        return "preferences";
      case "FINISH":
        return "check";
      case "UNDO":
        return "undo";
      case "EXCEPTION":
        return "warning";
      case "DELETE":
        return "close";
      default:
        return "preferences";
    }
  };

  const isControlEnabled = actionId => {
    if (disabledToolbar) return false;
    if (content && content) {
      return content.includes(actionId);
    }
    return false;
  };

  const onButtonClick = async (event, actionId) => {
    doAction(actionId);
  };

  const renderActionButton = (control) => {
    return (
      <Item
        key={control.ActionId}
        widget="dxButton"
        location="after"
        disabled={!isControlEnabled(control.ActionId)}
        options={{
          icon: findIcon(control.DecissionType),
          text: WidgetUtils.toCleanText(control.DisplayText),
          hint: control.Tooltip,
          stylingMode: "text",
          onClick: e => onButtonClick(e, control.ActionId),
        }}
      />
    );
  };

  const renderToolbar = () => {
    return (
      <Toolbar
        className={cn(classes.decisionsToolbar, "dx-theme-border-color")}
        id={widgetId}
        style={{height: ui.controlHeight + "em"}}
      >
        {buttons.map(control => (
          renderActionButton(control)
        ))}
      </Toolbar>
    );
  };

  return config
    ? renderToolbar()
    : null;
}
